/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Spinner } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { AgentBox, Readiness } from '@/pages/Agent';

/** Вкладка карточки дела: готовность (M32), команды агенту по делу (M32), похожие акты (M21) */
export function MatterAgentTab({ matterId }: { matterId: string }) {
  const { hasModule } = useAuth();
  const [cmd, setCmd] = useState('');
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      {hasModule('M32') && <div className="space-y-5"><Readiness matterId={matterId} /><AgentBox matterId={matterId} cmd={cmd} setCmd={setCmd} /></div>}
      {hasModule('M21') && <Similar matterId={matterId} />}
    </div>
  );
}

function Similar({ matterId }: { matterId: string }) {
  const [on, setOn] = useState(false);
  const { data, isFetching } = useQuery({ queryKey: ['similar', matterId], queryFn: () => api.get<any[]>(`/practice/similar/${matterId}`), enabled: on });
  return (
    <div className="card p-4">
      <div className="mb-2 flex items-center justify-between"><div className="text-sm font-medium">Похожие акты и документы</div>{!on && <Button size="sm" variant="secondary" onClick={() => setOn(true)}>Найти</Button>}</div>
      {isFetching && <Spinner />}
      {on && !isFetching && !data?.length && <div className="text-sm text-slate-500">Похожих документов не найдено. Загрузите судебные акты в документы, они будут проиндексированы.</div>}
      <ul className="space-y-2 text-sm">{(data ?? []).map((h, i) => (
        <li key={i}><Link className="text-brand-700 hover:underline" to={`/documents?open=${h.documentId}`}>{h.title}</Link><div className="line-clamp-3 text-xs text-slate-600">{h.text}</div></li>
      ))}</ul>
    </div>
  );
}
